import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import Modal from '@mui/material/Modal'
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../Button/Button'
import gift_box from '../../../../assets/images/gift_box.png'
import { userFirstLoginStyles as styles } from './userFirstLogin.tailwind.js'


const UserFirstLoginModal = ({ isOpen, onClose, getUser }) => {
  const { userPointsAndRewards } = useSelector((state) => state.reward);
  const points = userPointsAndRewards?.userTotalAvailablePoints;
  
  const data = {
    image: gift_box,
    message:
    (!points)
      ? 'You have been successfully signed up!'
      : `You have been awarded a bonus of ${points} points.`,
    heading: 'Congratulations!',
  };
  
  useEffect(() => {
    getUser(); // get updated user-info    
  }, [getUser])

  return (
     <Modal open={isOpen} onClose={onClose} disableAutoFocus>
       <div className={styles.container}>
         <div className={styles.imageBackground}>
           <button onClick={onClose} className={styles.closeButton}>
             <CloseIcon />
           </button>
           <div className={styles.imageContainer}>
             <img src={data.image} alt="Reward" className={styles.image} />
           </div>
         </div>

         <div className={styles.innerContainer}>
          <div className={styles.heading}>
            {data.heading}
          </div>
           <div>{data.message}</div>
           <Button variant="primary" onClick={onClose}>Close</Button>
         </div>
       </div>       
     </Modal>
   );
 };
 
 export default UserFirstLoginModal;